export default "__VITE_ASSET__Cd1BKh6M__"